import { LitElement, html, css } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { accessibility, formStyles, dialog, details, grid, markdown } from '../../utilities/styles';
import { editIcon, deleteIcon, addIcon, close, clock, address, web, provisionIcon, yellowTick, expandIcon, collapseIcon, submit, star, smallX, warning } from '../../utilities/icons';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, getUrlFromFileId, validateURL, validatePhone, releaseFormLockwithBeacon } from '../../utilities/formsUtilities';
import { AllInMemberConsumer } from '../Utilities/AllInMemberConsumer';
import { AllInMembersBase } from '../Utilities/AllInMembersBase';
import { eventTypes } from '../../utilities/eventUtilities';
import { formatDateString } from '../../utilities/eventUtilities';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInMemberProfileForm extends AllInMemberConsumer(AllInMembersBase(LitElement)) {
    static properties = {
        name: { type: String },
        view: { type: String },
        _processedProvisions: { type: Array, state: true },
        _message: { type: String, state: true },
    };
    constructor() {
        super();
    }
    get _form() {
        return this.shadowRoot.querySelector('form');
    }
    get _modal() {
        return this.shadowRoot.querySelector('dialog');
    }
    async connectedCallback() {
        super.connectedCallback();
        //this.renderRoot.querySelector('a')?.focus();
        this._processProvisions();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    async updated(changedProperties) {
        if (changedProperties.has('panel')) {
            if (this.panel == 'edit') {
                this.renderRoot.querySelector('input')?.focus();
            }
            else {
                this.renderRoot.querySelector('a')?.focus();
            }
            if (this.panel) {
                this._message = '';
            }
        }
        if (changedProperties.has('provisions')) {
            this._processProvisions();
        }
    }
    render() {
        let main = '';
        if (!this.membership || !this.membership?.provisions) {
            return html `<allin-loader></allin-loader>`;
        }
        let supportingDocuments = this._getEvidenceRequiredProvisions(true);
        let supportingDocumentsNeeded = this._getEvidenceRequiredProvisions();
        let supportingDocumentsStr = '';
        let actionLink = '';
        if (supportingDocuments && supportingDocuments.length > 0) {
            let docsArray = supportingDocuments.map((provision) => {
                let status = `Not submitted yet`;
                if (provision.evidence.length > 0) {
                    let sortedEvidence = provision.evidence.sort((a, b) => new Date(b.validUntil) - new Date(a.validUntil));
                    let latestEvidence = sortedEvidence[0];
                    if (latestEvidence.status == 'Approved') {
                        status = `Valid`;
                        if (latestEvidence.validUntil) {
                            if (new Date(latestEvidence.validUntil) < new Date()) {
                                status = `Expired on ${formatDateString(latestEvidence.validUntil, false, false)}`;
                            }
                            else {
                                status = `Valid until ${formatDateString(latestEvidence.validUntil, false, false)}`;
                            }
                        }
                    }
                    else if (latestEvidence.status == 'Rejected') {
                        status = `Rejected`;
                    }
                    else if (latestEvidence.status == 'AwaitingResponse') {
                        status = `Submitted, awaiting review`;
                    }
                    else if (latestEvidence.status == 'RequestInfo') {
                        status = `More information required`;
                    }
                }
                return html `<dd>${provision.details.name} <span class="bg_white">${status}</span></dd>`;
            });
            supportingDocumentsStr = html `\n                <dt>Supporting document</dt>\n                ${docsArray}\n            `;
        }
        if (supportingDocumentsNeeded && supportingDocumentsNeeded.length > 0) {
            actionLink = html `<a href="#" @click=${() => { this._updateContext({ dashboard: 'supporting_documents' }); }}><span aria-hidden="true">${submit}</span>Submit supporting documents</a>`;
        }
        let preferencesBlock = '';
        if (this.panel == 'edit') {
            let provisionsPre = html `<div class="collapsers">\n                <button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Expand all access details</button>\n                <button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Collapse all access details</button>\n            </div>`;
            let provisionChoices = [
                { name: 'not_needed', label: 'Not needed', icon: smallX },
                { name: 'Preferred', label: 'Preferred', icon: star },
                { name: 'Required', label: 'Required', icon: yellowTick },
            ];
            let provisionsLoop = this._processedProvisions.map((item) => {
                let markup = [];
                let tooltip = '';
                item.provisions.forEach((provision) => {
                    let selected = provision.memberProvision?.level;
                    if (!selected) {
                        selected = 'not_needed';
                    }
                    let provisionRadios = [];
                    provisionChoices.forEach(choice => {
                        provisionRadios.push(html `\n                            <div class='input-group'>\n                                <input type='radio' name='provision_${provision.id}' id='provision_${provision.id}_${choice.name}' value='${choice.name}' ?checked=${selected === choice.name} data-label='${provision.name} - ${choice.label}'>\n                                <label for='provision_${provision.id}_${choice.name}'>${choice.label}</label>\n                            </div>\n                        `);
                    });
                    let evidenceAlert = '';
                    if (provision?.evidenceRequired && provision.evidenceRequired === "1" && item.alert) {
                        evidenceAlert = html `\n                            <div class="alert message evidence-required">\n                                <span aria-hidden="true">${warning}</span>\n                                <span>${unsafeHTML(item.alert)}</span>\n                            </div>\n                        `;
                    }
                    markup.push(html `<div class='field-group grid'>\n                        <div class='options'>\n                            <h3 class='h5'>\n                                <strong>${provision.name}</strong>\n                            </h3>\n                            <p>\n                                ${provision.description}\n                            </p>\n                            <div class='flex'>\n                            ${provisionRadios}\n                            </div>\n                        </div>\n                        ${evidenceAlert}\n                        </div>`);
                });
                if (markup.length == 0) {
                    return '';
                }
                let icon = item.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                let message = '';
                if (item.message) {
                    message = html `<div class='additional_message message flex'><span aria-hidden="true" class="prov-image-span"><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${item.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                        e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                    } }} /></span><span class="prov-message-span">${unsafeHTML(item.message)}</span></div>`;
                }
                return html `\n                    <details class="provisions">\n                        <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${item.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                    e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                } }} />${item.title}</summary>\n                        <div class="panel">\n                            ${markup}\n                            ${message}  \n                        </div>\n                    </details>\n                    `;
            });
            let preferencesSelector = html `<allin-multiselect name="preferences" list=${JSON.stringify(eventTypes)} value=${JSON.stringify(this.membership.preferences)}></allin-multiselect>`;
            preferencesBlock = html `\n                <form @submit=${this._handleSubmit}>\n                    <h3>Event preferences</h3>\n                    <p class="small">Please choose events that you prefer. This will be reflected on event listings and location listings.</p>\n                    ${preferencesSelector}\n                    <h3>Access details</h3>\n                    ${provisionsPre}\n                    <div class="message notice" aria-live="polite"></div>\n                    ${provisionsLoop}\n                    <input type="hidden" name="action" value="${this.action}-edit-membership-profile" />\n                    <div class="button-group">\n                        <button type="submit">Submit</button>\n                    </div>   \n                    <hr>\n                    <a href="javascript:void(0)" @click=${this._handleClick}>${deleteIcon}Cancel</a>\n                </form>\n            `;
        }
        else {
            let provisionsLoop = [];
            if (this._processedProvisions.length == 0) {
                provisionsLoop.push(html `<allin-loader loading></allin-loader>`);
            }
            else {
                provisionsLoop = this._processedProvisions.map((item) => {
                    let markup = [];
                    item.provisions.forEach((provision) => {
                        if (!provision.memberProvision) {
                            return;
                        }
                        let status = provision.memberProvision.level;
                        let statusStr = '';
                        if (status == 'Required') {
                            statusStr = html `<div class="status">\n                            <strong><span aria-hidden="true">${yellowTick}</span>${status}</strong>\n                        </div>`;
                        }
                        else {
                            statusStr = html `<div class="status">\n                            <strong><span aria-hidden="true">${star}</span>${status}</strong>\n                        </div>`;
                        }
                        markup.push(html `\n                        \n                        <div class="provision item grid grid--status">\n                            ${statusStr}\n                            <div class="text">\n                                <p>${provision.name}</p>\n                            </div>\n                        </div>\n                                \n                        `);
                    });
                    if (markup.length == 0) {
                        return '';
                    }
                    let icon = item.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                    return html `\n                        <details class="provisions">\n                        <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${item.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                        e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                    } }} />${item.title}</summary>\n                        <div class="panel">\n                            ${markup}\n                        </div>\n                    </details>\n                    `;
                });
            }
            let hasProvisions = provisionsLoop.filter((item) => item != '');
            let provisionsPre = '';
            if (hasProvisions.length == 0) {
                provisionsPre = html `<p class="small">No access details are attached to this profile</p>`;
            }
            else {
                provisionsPre = html `<div class="collapsers">\n                    <button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Expand all access details</button>\n                    <button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Collapse all access details</button>\n                </div>`;
            }
            let preferences = '';
            if (this.membership.preferences && this.membership.preferences.length > 0) {
                preferences = this.membership.preferences.map(pref => eventTypes.find(p => p.name == pref)?.label || pref).join(', ');
            }
            else {
                preferences = html `<p>No event preferences have been set yet <a href="javascript:void(0)" @click=${this._handleClick}>Set preferences</a></p>`;
            }
            preferencesBlock = html `\n                <div class="flex preferences-header">\n                    <h3>Event preferences</h3>\n                    ${preferences}\n                </div>\n\n                <h3>Access details</h3>\n                ${provisionsPre}\n                ${provisionsLoop}\n                <hr><div class="flex">\n                    <a href="javascript:void(0)" @click=${this._handleClick}>${editIcon}Edit these details</a>\n                    <a href="javascript:void(0)" @click=${this._handleModal}>${deleteIcon}Remove my profile</a>\n                </div>\n                 <dialog>\n                    <button class="close" autofocus @click=${this._handleModal}><span aria-hidden="true">${deleteIcon}</span>Cancel</button>\n                    <p>\n                        Are you sure you want to remove your profile? This will delete all of your access details and unshare your profile from any organisations. This action cannot be undone.\n                    </p>\n                    <button @click=${this._handleDeleteClick}>Remove my profile</button>\n                </dialog>\n            `;
        }
        main = html `\n            <div class="bg bg_grey profile-card">\n                <dl>\n                    <dt>My name</dt>\n                    <dd>${this.user.firstName} ${this.user.lastName}</dd>\n                    <dt>My member number</dt>\n                    <dd>${this.membership.allInMemberNumber}</dd>\n                    ${supportingDocumentsStr}\n                    ${actionLink}\n                </dl>\n            </div>\n            <div class="bg bg_grey">\n               ${this._message ? html `<div class="message notice" aria-live="polite">${this._message}</div>` : ''}\n               ${preferencesBlock}\n            </div>\n        `;
        return html `${main}`;
    }
    _handleClick(e) {
        e.preventDefault();
        this.panel = this.panel == 'edit' ? '' : 'edit';
        this._updateContext({ panel: this.panel });
    }
    async _handleSubmit(e) {
        e.preventDefault();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        this._message = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('[type="submit"]');
        let valid = validateForm(this._form, formResponse);
        if (!valid) {
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        //formData = JSON.stringify(Object.fromEntries(formData));
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (!response.error) {
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                this.membership = response.membership;
                this._processProvisions();
                submitButton.disabled = false;
                formResponse.innerHTML = 'Your changes have been saved';
                this._message = 'Your changes have been saved';
                this._updateContext({ membership: this.membership, panel: '' });
            }
            else {
                formResponse.innerHTML = response.message || 'An error occurred';
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        }
        ;
    }
    _processProvisions() {
        let processedProvisions = this.provisions.map((provision) => {
            provision.provisions.map(p => {
                let memberProv = this.membership.provisions.find(mp => mp.standard.id == p.id);
                if (memberProv) {
                    p.memberProvision = memberProv;
                }
                else {
                    if (p.memberProvision) {
                        delete p.memberProvision;
                    }
                }
                return p;
            });
            return provision;
        });
        this._processedProvisions = [...processedProvisions];
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    _handleCollapse(e) {
        let target = e.currentTarget.dataset.collapse;
        if (target) {
            let targets = this.shadowRoot.querySelectorAll(`.${target}`);
            if (e.currentTarget.getAttribute('aria-expanded') == 'true') {
                e.currentTarget.setAttribute('aria-expanded', 'false');
                targets.forEach(target => target.classList.remove('open'));
            }
            else {
                e.currentTarget.setAttribute('aria-expanded', 'true');
                targets.forEach(target => target.classList.add('open'));
            }
        }
    }
    _validateURL(e) {
        if (e.target.type !== 'url')
            return;
        validateURL(e.target);
    }
    _slotURLChangeOnline(e) {
        const value = e.target.value?.trim();
        if (value && !/^https?:\/\//i.test(value)) {
            e.target.value = `https://${value}`;
        }
    }
    // New custom function to get Online event link data to be passed to allin-navigation
    _getSidebarLinks() {
        const links = [];
        // Online access link (only for Online events)
        if (this.eventIsOnline) {
            let accessLink = this._eventDataProcessed.find(item => item.name === 'locationUrl');
            if (accessLink) {
                accessLink.value = decodeEntities(this._eventData?.locationUrl ?? '');
                if (accessLink.value) {
                    links.push({ label: 'Online access link', url: accessLink.value });
                }
            }
        }
        return links;
    }
    _handleModal(e) {
        e.preventDefault();
        if (this._modal.open) {
            this._modal.close();
        }
        else {
            this._modal.showModal();
        }
    }
    async _handleDeleteClick(e) {
        e.preventDefault();
        this._modal.classList.add('loading');
        e.currentTarget.disabled = true;
        let action = 'member-dashboard-remove-membership-profile';
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: JSON.stringify({ action: action }),
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (!response.error) {
                this.membership = response.membership;
                this._processProvisions();
                this._updateContext({ membership: this.membership, panel: '', dashboard: '' });
                window.location.href = '/';
            }
            else {
                console.error('Error removing membership profile:', error);
            }
        }
        catch (error) {
            console.error('Error removing membership profile:', error);
        }
    }
    static styles = [
        ...super.styles,
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        markdown,
        css `
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .bg a:hover{
            text-decoration:underline;
        }



        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {

            .button-group button:hover svg, .return:hover svg{
                transform:none;
            }
        }
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child:not(.duet-date__cell){
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
                background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
                font-weight: var(--allin-button-font-weight, 600);
                color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            max-height:0;
            overflow:hidden;
            transition:all var(--transition) ease;
            transition-behavior: allow-discrete;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            max-height:700px;
            box-sizing: border-box;
            overflow:visible;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        .add_uploader{
            background-color: var(--allin-button-bg-color, #472961);
            color: #fff;
            margin-bottom: 1.5rem;
        }
        .add_uploader span svg {
            background-color: #fff;
            transform: translate(0px, 3px);
        }

        .add_uploader:hover span svg {
            background-color: transparent;
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1rem;

            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem 0.5rem 3rem;
            &:has(>.field-group){
                padding-left:1rem;
            }
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        .instances{
            padding:0;
            margin:0;
            list-style:none;
        }

        .instances li:not(:last-child){
            margin-bottom:1rem;
            padding-bottom:1rem;
            border-bottom:1px solid var(--allin-highlight-color,#472961);
        }

        .instances dl{
            display:grid;
            grid-template-columns: max-content 1fr;
            gap:1rem;
        }

        .instances dl dt{
            font-weight:500;
        }
        
        dd h4{
            margin:0 0 0.5rem 0;
        }

        dd p{
            margin-bottom:1rem;
        }
        p:has(+.provisions){
            grid-column: 1 / -1;
            margin-top:2rem;
            margin-bottom:0;
        }
        .repeater{
            padding:0 2rem;
        }
        allin-location-search .bg{
            background-color:var(--color-bg);
        }
        allin-location-search ul{
            list-style:none;
            padding:0;
            margin:1rem 0;
        }
        allin-location-search li, allin-location-search .selected-location{
            margin-bottom:0.5rem;
            display:grid;
            grid-template-columns: 3rem 1fr auto;
            gap:1rem;
            align-items:center;
            img{
                width:3rem;
                height:3rem;
                object-fit:cover;
            }
            button{
                height:fit-content;
            }
        }
        .searchboxes {
            display: grid;
            grid-template-columns: 1fr auto;
            width: 100%;
            max-width: 800px;
            margin-bottom: 2rem;
            position:relative;
        }

        .searchbox {
            position: relative;
            label {
                margin-bottom: 0.5rem;
            }
        }
        .searchbox svg {
            position: absolute;
            left: 0.5rem;
            bottom: 0.8rem;
            width: 1.5rem;
            height: 1.5rem;
        }

        .searchbox input{
            padding-left:2.5rem;
            border-radius:0.5rem 0 0 0.5rem;
        }
        .searchboxes button{
            border-radius:0 0.5rem 0.5rem 0;
            height:calc(3rem + 2px);
            align-self:end;
        }
        .no-location button{
            margin:1rem 0 0 auto;
            display:block;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }

        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }
        .grid--status{
            grid-template-columns: 10ch 1fr;
            gap:1rem;
            align-items:center;
            .status{
                padding:0.15rem;
                border:1px solid #000;
                strong{
                    display:flex;
                    align-items:center;
                    gap:0.2rem;
                    span{
                        width:1rem;
                        height:1.2rem;
                        display:block;
                    }
                    svg{
                        width:1rem;
                        height:1rem;
                    }
                }
            }
            
        }
        @media screen and (min-width:700px){
            dl>a{
                grid-column:2/3;
                margin-top:0.5rem;
            }
        }
        .bg+.bg{
            margin-top:3rem;
        }
        .field-group{
            padding:1rem 0;
            border-top:1px solid var(--allin-border-color,#707070);
            &+.field_group{
                margin-top:1rem;
            }
            allin-tooltip{
                justify-self: end;
            }
            .input-group{
                gap:0.4rem;
                
                align-items: center;
                input{
                   margin:0;
                }
                label{
                    max-width:unset;
                    font-weight:400;
                    display:flex;
                    align-items: center;
                    gap:0.1rem;
                    svg,span{
                        height:0.75rem;
                        width: 0.75rem;
                    }
                    span{
                        display:flex;
                        align-items:center;
                        justify-content:center;
                    }
                }
            }
        }
        @media screen and (min-width:1000px){
            .field-group{
                grid-template-columns: 3fr 1fr;   
                gap:1rem;         
                .input-group{
                   margin-bottom:0; 
                }
            }
        }
        form{
            gap:0;
        }
        .h5{
            font-size:1rem;
            margin:0 0 0.5rem;
        }
        .preferences-header{
            justify-content:flex-start;
            gap:2rem;
            align-items:center;
            p{
                margin:0;   
            }
        }

        .options .flex{
            flex-wrap: wrap;
            row-gap: 1rem;
            column-gap: 1rem;
        }

        .message:empty{
            display:none;
        }
        .message.flex{
            justify-content:flex-start;
            gap:1rem;
        }

        .message.flex span.prov-image-span{
            width: 36px;
            aspect-ratio: 23.98/23.8; 
        }
        
        .message.evidence-required{
            grid-column: span 2;
            background-color: var(--color-grey, #e8e8e8);
            display: flex;
            column-gap: 1rem;
        }

        `
    ];
}
